const baseStyle = {
    container: {
        bg: "primary.500",
    },
    icon: {
        color: "greyscale.100",
    },
    title: {
        color: "greyscale.100",
    },
    subtitle: {
        color: "primary.200",
    },
    link: {
        color: "primary.200",
        textDecoration: "underline",
    },
    closeButton: {
        color: "primary.200",
    },
};
const variants = {
    secondary: {
        container: {
            bg: "greyscale.400",
        },
        icon: {
            color: "primary.500",
        },
        title: {
            color: "primary.900",
        },
        subtitle: {
            color: "greyscale.700",
        },
        link: {
            color: "primary.500",
            textDecoration: "none",
        },
        closeButton: {
            color: "greyscale.600",
        },
    },
    warning: {
        container: {
            bg: "warning.200",
        },
        icon: {
            color: "warning.500",
        },
        title: {
            color: "primary.900",
        },
        subtitle: {
            color: "greyscale.700",
        },
        link: {
            color: "primary.500",
            textDecoration: "none",
        },
        closeButton: {
            color: "greyscale.600",
        },
    },
    danger: {
        container: {
            bg: "danger.200",
        },
        icon: {
            color: "danger.500",
        },
        title: {
            color: "primary.900",
        },
        subtitle: {
            color: "greyscale.700",
        },
        link: {
            color: "primary.500",
            textDecoration: "none",
        },
        closeButton: {
            color: "greyscale.600",
        },
    },
    success: {
        container: {
            bg: "success.200",
        },
        icon: {
            color: "success.500",
        },
        title: {
            color: "primary.900",
        },
        subtitle: {
            color: "greyscale.700",
        },
        link: {
            color: "primary.500",
            textDecoration: "none",
        },
        closeButton: {
            color: "greyscale.600",
        },
    },
};
const Banner = { variants, baseStyle };
export default Banner;
